import HttpGlobal from "../Global/HttpGlobal.class";
import { nativeGatewayBaseUrl } from "../../../native/nativeMode";

/**
 * Confirmación de renovación con el enlace native del aviso (F3.4 P4, D20):
 * `renewal-confirmation?t=<token firmado por ms-agl>`. Ruta pública del gateway,
 * sin sesión ni bearer: el token del enlace es la credencial.
 */
export type NativeRenewalConfirmationOutcome =
  | { kind: "CONFIRMED" | "ALREADY_CONFIRMED"; renewalYear: number }
  | { kind: "EXPIRED" }
  | { kind: "ERROR" };

export const confirmRenewalWithToken = async (
  token: string
): Promise<NativeRenewalConfirmationOutcome> => {
  const base = nativeGatewayBaseUrl();
  if ("" === base) {
    return { kind: "ERROR" };
  }
  try {
    const response = await new HttpGlobal().generalPost({
      url: `${base}/customer/renewal-confirmations`,
      dataRequest: { token },
    });
    const status = response?.status;
    if (
      ("CONFIRMED" === status || "ALREADY_CONFIRMED" === status) &&
      "number" === typeof response?.renewalYear
    ) {
      return { kind: status, renewalYear: response.renewalYear };
    }
    return { kind: "ERROR" };
  } catch (error) {
    return 410 === (error as { status?: number } | null)?.status
      ? { kind: "EXPIRED" }
      : { kind: "ERROR" };
  }
};
